import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ReactComponent as PageImage } from '../../assets/icons/401.svg';

import { colors } from '../../theme';
import Button from "../../components/global/button";
import {ReactComponent as DeleteIcon} from "../../assets/icons/delete-icon.svg";
import GlobalButton from "../../components/global/button";

const Forbidden = (props) => {
    return (
        <PageContainer>
            <PageImage />
            <TextContainer>
                <Typography variant="h4">Error 401</Typography>
                <Typography variant="h2">Authorization Required for Access</Typography>
                <Typography>It appears that session has expired or your A-Number is not recognized in the system.</Typography>
                <Typography sx={{ mt: '1em' }}>
                    If you require an access, please contact
                    <a href="mailto:ttportal@bcit.ca">ttportal@bcit.ca</a>, if you are a new instructor you should have been added to the system but your program might not have been yet.
                </Typography>
                <Typography sx={{ mt: '1em' }}>Click the sign out button if you wish to log back into the application (where your session has expired).</Typography>
                <Typography sx={{ mt: '1em' }}>
                    <GlobalButton 
                        variant="contained" 
                        text="sign out" 
                        buttoncolor={colors.red} 
                        onClick={() => {
                            window.location.replace("https://login.bcit.ca/cas/logout");
                        }} />
                </Typography>
            </TextContainer>
        </PageContainer>
    );
};

export default Forbidden;


const PageContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bg};

    svg {
        width: 17vw;
        height: auto;
    }

    h4 {
        text-transform: uppercase;
        font-weight: 700;
        color: ${colors.blue.main};
    }

    h2 {
        font-size: 40px;
        margin-bottom: 0.5em;
    }

    p {
        font-size: 22px;
    }

    a {
        text-decoration: none;
        color: ${colors.blue.main};
        font-weight: 700;
        margin: 0 5px;
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 2em;
    max-width: 50vw;
`;
